import * as Dialog from '@radix-ui/react-dialog';
import { Sparkles, Loader2 } from 'lucide-react';
import { useI18n } from '@/contexts/i18n-hook';

interface IADialogProps {
  mostrarDialogIA: boolean;
  setMostrarDialogIA: (mostrar: boolean) => void;
  descricaoMaquinaIA: string;
  setDescricaoMaquinaIA: (descricao: string) => void;
  analisandoIA: boolean;
  handleAnalisarComIA: () => void;
}

export function IADialog({
  mostrarDialogIA,
  setMostrarDialogIA,
  descricaoMaquinaIA,
  setDescricaoMaquinaIA,
  analisandoIA,
  handleAnalisarComIA,
}: IADialogProps) {
  const { t } = useI18n();
  return (
    <Dialog.Root open={mostrarDialogIA} onOpenChange={setMostrarDialogIA}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/50 z-[60]" />
        <Dialog.Content className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg shadow-xl w-[90vw] max-w-md z-[60] p-6">
          <Dialog.Title className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
            <Sparkles className="h-5 w-5 text-purple-600" />
            {t('apreciacaoModais.editarParte.ia.titulo')}
          </Dialog.Title>
          
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {t('apreciacaoModais.editarParte.ia.descricaoRotulo')} <span className="text-red-500">*</span>
              </label>
              <textarea
                value={descricaoMaquinaIA}
                onChange={(e) => setDescricaoMaquinaIA(e.target.value)}
                placeholder={t('apreciacaoModais.editarParte.ia.descricaoPlaceholder')}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm min-h-[100px]"
                rows={4}
              />
              <p className="mt-1 text-xs text-gray-500">
                {t('apreciacaoModais.editarParte.ia.descricaoAjuda')}
              </p>
            </div>

            <div className="bg-blue-50 border border-blue-200 rounded-md p-3">
              <p className="text-xs text-blue-800">
                <strong>{t('apreciacaoModais.editarParte.ia.dicaRotulo')}</strong> {t('apreciacaoModais.editarParte.ia.dicaTexto')}
              </p>
            </div>
          </div>

          <div className="flex justify-end space-x-3 mt-6 pt-4 border-t border-gray-200">
            <Dialog.Close asChild>
              <button className="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50">
                {t('comum.acao.cancelar')}
              </button>
            </Dialog.Close>
            <button
              onClick={handleAnalisarComIA}
              disabled={analisandoIA || !descricaoMaquinaIA.trim()}
              className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-purple-600 hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {analisandoIA ? (
                <>
                  <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                  {t('apreciacaoModais.editarParte.ia.analisando')}
                </>
              ) : (
                <>
                  <Sparkles className="h-4 w-4 mr-2" />
                  {t('apreciacaoModais.editarParte.ia.botaoAnalisar')}
                </>
              )}
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

